import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { LOGO_URL } from "../data/constants";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Sikeres bejelentkezés");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "rounded-none border border-border bg-white h-12 focus-visible:ring-0 focus-visible:border-foreground";

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md border border-foreground bg-background p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="A/Z logó" className="h-11 w-11 object-contain" />
          <div>
            <span className="font-serif-display text-xl block leading-tight">Admin belépés</span>
            <span className="overline text-muted-foreground">Pénzügyi Megoldások</span>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-6" data-testid="login-form">
          <div>
            <Label className="overline block mb-2 text-muted-foreground">Felhasználónév</Label>
            <Input data-testid="login-username" className={inputCls} value={username}
              onChange={(e) => setUsername(e.target.value)} placeholder="felhasználónév" autoFocus />
          </div>
          <div>
            <Label className="overline block mb-2 text-muted-foreground">Jelszó</Label>
            <Input data-testid="login-password" type="password" className={inputCls} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full rounded-none bg-foreground text-background hover:bg-[#2A2A2A] h-12 group">
            <Lock className="mr-2 h-4 w-4" />
            {loading ? "Belépés…" : "Belépés"}
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
